module.exports = "<div class=\"infoGraphicNumber\" *ngIf=\"labelData\">\r\n    {{infoGraphic.title}}: {{labelData}}\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/charts/infoGraphicNumber/infoGraphicNumber.component.html
// module id = ../../../../../app/shared/components/charts/infoGraphicNumber/infoGraphicNumber.component.html
// module chunks = main